import { createFileRoute } from '@tanstack/react-router'
import { InterfaceTranslationEditor } from '../-InterfaceTranslationEditor'

export const Route = createFileRoute('/settings/translations/interface/$locale/$key')({
  component: EditInterfaceTranslationPage,
})

function EditInterfaceTranslationPage() {
  // The route param `key` is passed as `translationKey` — React reserves `key`.
  const { locale, key } = Route.useParams()
  return <InterfaceTranslationEditor locale={locale} translationKey={key} />
}
